function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.762,
  cy: 17.305,
  r: 15,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2452_71092)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.87 19.63l.87 1.85.25.56c.3.72.01 1.53-.7 1.88-.25.13-.53.27-.82.32a1.42 1.42 0 01-1.56-.84l-1.25-2.67-.1-.2-1.28.53c-.18.08-.37.18-.56.25-.7.27-1.5 0-1.82-.68-.46-.91-.89-1.84-1.3-2.77-.32-.74.03-1.55.8-1.9a21.7 21.7 0 003.79-2.26 18.53 18.53 0 004.59-4.75c.64-.99 2.07-.9 2.57.17 1.27 2.71 2.54 5.43 3.79 8.15.5 1.08-.36 2.17-1.56 2.07a17.4 17.4 0 00-5.59.24l-.12.05zm2.95-1.67l-2.8-6-.15.18a22.29 22.29 0 01-3.54 3.02 22.2 22.2 0 01-3.36 1.92c-.15.07-.26.16-.17.35L11.99 20c.06.15.18.18.32.12l.18-.08a22.78 22.78 0 017.17-1.96c.38-.05.75-.07 1.16-.11zm2.9.1c.26.03.35-.1.24-.34l-3.72-7.99c-.11-.25-.28-.26-.45-.03l-.75 1.06c-.09.12-.1.2-.03.32l.78 1.66 2.34 5.03c.04.08.12.17.2.18.46.05.92.07 1.39.1zM16.6 19.9l-.82.23.1.23 1.04 2.22c.16.33.4.42.74.25.2-.1.23-.18.13-.38l-.79-1.7-.4-.85z"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.285,
  cy: 10.834,
  r: 2.048,
  fill: "#BF3030"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2452_71092"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15.8v16H0z",
  transform: "translate(9.488 8.262)"
})));

function SvgNotificationActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.fbe062ae.svg";
export { ForwardRef as ReactComponent };